<template>
    <div class="container">
        <div class="row">
            <div class="col-4">
                <side-menu/>
            </div>
            <div class="col-8">
                <contents-display/>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'CourseContents',
        props: ["initialCourse", "edit", "tab"],
        data: function () {
            return {
                course: this.initialCourse,
                editEnabled: this.edit,
                selectedTab: this.tab,
            };
        },
        watch: {
            edit: function (newVal, oldVal) {
                this.editEnabled = newVal;
            },

        },
        methods: {
            clicked(tabIndex, page, chapter) {
                this.selectedTab = tabIndex;
                this.$emit("tabClick", tabIndex, page, chapter);
            },
        },
        mounted: function () {
            //console.log("Course actions loaded", this.course, this.editEnabled);
        },
    }
</script>

<style scoped>
</style>
